// extracted by mini-css-extract-plugin
export var table = "_w7-0";